__turbopack_context__.v({
  "close": "TopBanner-module-scss-module__RuZwsW__close",
  "desktop": "TopBanner-module-scss-module__RuZwsW__desktop",
  "mobile": "TopBanner-module-scss-module__RuZwsW__mobile",
  "root": "TopBanner-module-scss-module__RuZwsW__root",
});
